import { Button, Form, IFormRender, Label, Radio, RadioGroupFormField, TextFormField } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import EmployeePickerFormField from 'components/domain/member/EmployeePickerFormField/EmployeePickerFormField';
import { t } from 'i18next';
import { useState } from 'react';
import { ClassName } from 'types/ClassName';
import v_max_length from 'utils/validations/v_max_length';
import { v_require } from 'utils/validations';

const CHECKLIST_NAME_MAX_LENGTH = 200;

export interface IEquipmentInspectionChecklistFormProps {
  className?: ClassName;
  initialFormData?: IEquipmentInspectionChecklistFormData;
  onFormSubmit: (formData: IEquipmentInspectionChecklistFormData) => void;
}

export enum EquipmentChecklistType {
  EQUIPMENT_ONLY = 'equipment-only',
  EQUIPMENT_AND_ATTACHMENT = 'equipment-and-attachment',
}

export interface IEquipmentInspectionChecklistFormData {
  name: string;
  type: string;
  defaultInspector?: string;
}

const EquipmentInspectionChecklistForm = (props: IEquipmentInspectionChecklistFormProps) => {
  const { className, initialFormData, onFormSubmit } = props;

  const [formData] = useState<IEquipmentInspectionChecklistFormData>(
    initialFormData ?? { name: '', type: EquipmentChecklistType.EQUIPMENT_ONLY, defaultInspector: undefined }
  );

  const handleSubmit = async (formData: IEquipmentInspectionChecklistFormData) => {
    onFormSubmit({ ...formData, name: formData.name.trim() });
  };

  const classes = classNames('equipment-inspection-checklist-form', className);

  const renderFormFields = ({ ...form }: IFormRender<IEquipmentInspectionChecklistFormData>) => (
    <>
      <Label>{t('Name')}</Label>
      <TextFormField
        name="name"
        form={form}
        restrictTo={{ maxLength: CHECKLIST_NAME_MAX_LENGTH }}
        validations={[
          { validation: v_require, args: { message: t('Name is required') } },
          {
            validation: v_max_length,
            args: {
              max: CHECKLIST_NAME_MAX_LENGTH,
              message: t('Name must be {{max}} characters or fewer', { max: CHECKLIST_NAME_MAX_LENGTH }),
            },
          },
        ]}
      />
      <RadioGroupFormField name="type" form={form}>
        <Radio value={EquipmentChecklistType.EQUIPMENT_ONLY} label={t('Equipment Only')} />
        <Radio value={EquipmentChecklistType.EQUIPMENT_AND_ATTACHMENT} label={t('Equipment & Trailer')} />
      </RadioGroupFormField>
      <Label>{t('Default Inspector')}</Label>
      <EmployeePickerFormField name="defaultInspector" form={form} />
      <Button type={'primary'} onClick={form.handleSubmit} className={'mt-6'}>
        {t('Submit')}
      </Button>
    </>
  );

  return (
    <div className={classes}>
      <Form render={renderFormFields} onSubmit={handleSubmit} data={formData} />
    </div>
  );
};

export default EquipmentInspectionChecklistForm;
